const wpaBridge = (function wpaBridge() {
  // 用来缓存postMsg过来的接待配置信息
  let msgData = {};
  const flagKey = 'QD_PM';
  const flagVal = 'CHAT';

  let hasDragged = false;

  /**
   * 是否在iframe中
   * @returns boolean
   */
  function inIframe() {
    const { href } = location;
    // 当url中包含 kufin && (fid || wpaId) 参数时，就默认为是非 iframe模式。而应该是当作第三方将我们的im整个嵌入到他们的网站了。
    if (href.indexOf('kfuin') > -1 && (href.indexOf('fid') > -1 || href.indexOf('wpaId') > -1)) {
      return false;
    }
    return window !== window.parent;
  }


  // 广播消息
  function sendMsg(postMsgData, sendFlagVal) {
    let sendData = Object.assign({}, msgData, postMsgData);
    const gflagVal = sendFlagVal || flagVal;
    if (!sendData[flagKey] || sendData[flagKey] !== gflagVal) {
      sendData[flagKey] = gflagVal;
    }
    sendData = typeof sendData !== 'string' ? JSON.stringify(sendData) : sendData;
    console.log('[sendMsg]', sendData);
    window.parent.postMessage(sendData, '*');
  }

  // 接收消息
  function receiveMsg(target, cb) {
    const listener = function (e) {
      const postMsg = e.data;
      if (postMsg) {
        try {
          msgData = JSON.parse(postMsg);
          console.log('[receiveMsg]', msgData);
        } catch (ex) {
          console.warn(`PostMsg Parse Error ${postMsg}`, ex);
          return;
        }
        typeof cb === 'function' ? cb(msgData) : '';
      } else {
        return;
      }
    };
    // 绑定前先remove，防止重发绑定
    target.removeEventListener('message', listener);
    target.addEventListener('message', listener);
  }

  // 事件监听
  function postMsgListener(msgData, IM) {
    if (typeof msgData !== 'object') return;

    const { act } = msgData;
    switch (act) {
      case 'INIT':
      case 'OPEN':
      case 'UPDATE_UNREAD':
      case 'DISCONNECT':
      case 'SM_MANUAL_INVITE':
        // 调用IM暴露的 方法，进行后续处理
        IM.operateIframe(act, msgData);
        break;

      default:
        console.log('[postMsgListener]未被处理的消息', msgData);
    }
  }

  // 绑定监听
  function bindListener(IM) {
    if (typeof (IM) === 'undefined') {
      console.error('[wpaBridge]未绑定IM对象');
      return;
    }

    receiveMsg(window, (msgData) => {
      postMsgListener(msgData, IM);
    });
  }

  // 绑定拖动逻辑
  function bindDragEvent(dragArea) {
    if (typeof (dragArea) === 'undefined') {
      console.error('[bindDragEvent]未绑定DOM节点');
    }

    let dragging; // 是否激活拖拽状态
    let tLeft; let tTop; // 鼠标按下时相对于选中元素的位移

    // 监听鼠标按下事件
    const mousedown = function (e) {
      const { kfuin } = msgData;
      hasDragged = false;
      dragging = true; // 激活拖拽状态
      tLeft = e.screenX; // 鼠标按下时和选中元素的坐标偏移:x坐标
      tTop = e.screenY; // 鼠标按下时和选中元素的坐标偏移:y坐标
      sendMsg({
        act: 'DRAG_START',
        kfuin,
      });
      // 监听鼠标放开事件
      document.addEventListener('mouseup', mouseup);
      document.addEventListener('mousemove', mousemove);
    };

    const mouseup = function () {
      const { kfuin } = msgData;
      dragging = false;
      // mask.remove();
      sendMsg({
        act: 'DRAG_END',
        kfuin,
      });
      document.removeEventListener('mouseup', mouseup);
      document.removeEventListener('mousemove', mousemove);
    };
    const mousemove = function (e) {
      const { kfuin } = msgData;
      if (dragging) {
        const moveX = e.screenX - tLeft;
        const moveY = e.screenY - tTop;
        if (Math.abs(moveX) + Math.abs(moveY) > 5) {
          hasDragged = true;
        }

        sendMsg({
          act: 'DRAG_MOVE',
          kfuin,
          data: {
            x: moveX,
            y: moveY,
          },
        });
      }
    };

    dragArea.removeEventListener('mousedown', mousedown);
    dragArea.addEventListener('mousedown', mousedown);
  }

  function isHasDragged() {
    return hasDragged;
  }

  return {
    inIframe,
    sendMsg,
    bindListener,
    bindDragEvent,
    isHasDragged,
  };
}());

// wpaBridge.sendMsg(msgData);
// wpaBridge.bindListener(IM);
// wpaBridge.bindDragEvent(document.querySelector('.mod-title'));

export default wpaBridge;
